const CONFIG = {
    API: {
        BASE_URL: 'https://api.air360.app',
        ACCESS_TOKEN: '8c0a0f44-923c-485d-8c71-5690124d2f2f',
    },
    MAPBOX: {
        URL: 'https://www.mapbox.com/about/maps',
        PUBLIC_TOKEN: 'pk.eyJ1IjoicmlnZyIsImEiOiJjbHp6bjhrOTcwOGFiMmpxMng0a3Q5aTdrIn0.eku67lV9-KjnkBI7zCw8_Q',
        SECRET_TOKEN: 'sk.eyJ1IjoicmlnZyIsImEiOiJjbHp6b2pkNzUxZHRvMmxvZGg3NmZmczdzIn0.MtcphtPMmzX5eVVDkk6f-Q',
        REVERSE_GEOCODE: 'https://api.mapbox.com/search/geocode/v6/reverse?longitude={longitude}&latitude={latitude}&access_token={token}&limit=1',
        CONTRIBUTE: 'https://labs.mapbox.com/contribute/#/',
    },
    OPENSTREETMAP: {
        URL: '',
        ABOUT: 'https://www.openstreetmap.org/about/',
    },
    APP: {
        VERSION: '1.0.0',
        ENVIRONMENT: process.env.NODE_ENV || 'development', // 'development' or 'production'
    },
    INSTAPATHMOBILE: {
        APPID: '6630364972',
    },
    DEFAULT_HEADERS: {
        'Content-Type': 'application/json',
    },
    GOOGLE: {
        SITE_KEY_V3: '6LdGm60qAAAAALUxLZ0BOpPKzfiyGtoJU4Ax82Fk',
        SITE_KEY_V2: '6LcJErQqAAAAAIPGRWjCgON5ysspbozbL6bfbIQZ',
        TEST_KEY: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    },
    PLAN_IDS: {
        FREE: 'free',
        PRO: 'pro',
        BUSINESS: 'business',
        ENTERPRISE: 'enterprise',
    },
    MEASURE: {
        SIDEBAR_WIDTH: 180,
    }
};

export default CONFIG;